import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import WhySection from '../components/WhySection';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const PourquoiSunSpotPage = () => {
  return (
    <>
      <Helmet>
        <title>Pourquoi j'ai créé Sun-Spot - Histoire personnelle</title>
        <meta name="description" content="Découvrez l'histoire personnelle derrière la création de Sun-Spot : un besoin réel de découvrir des spots panoramiques accessibles près de chez soi." />
        <link rel="canonical" href="https://sun-spot.app/pourquoi-sun-spot" />
      </Helmet>
      
      <div className="pt-16">
        <WhySection />
        
        {/* Navigation between pages */}
        <div className="bg-amber-50 py-8">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center">
              <Link 
                to="/comment-ca-marche" 
                className="flex items-center space-x-2 text-amber-700 hover:text-amber-900 transition-colors duration-200"
              >
                <ChevronLeft className="w-5 h-5" />
                <span>Comment ça marche</span>
              </Link>
              
              <Link 
                to="/philosophie" 
                className="flex items-center space-x-2 text-amber-700 hover:text-amber-900 transition-colors duration-200"
              >
                <span>Notre philosophie</span>
                <ChevronRight className="w-5 h-5" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PourquoiSunSpotPage;